var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "tab-detail" } },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("whatsapp.whatsappV1ChannelDetail"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.$t("whatsapp.manageWhatsappV1Channel"))),
        ]),
      ]),
      _vm._v(" "),
      _c("a-form", [
        _c(
          "div",
          { staticClass: "form-wrapper" },
          [
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("whatsappChannel.channelName"))),
                ]),
                _vm._v(" "),
                _c("a-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t("whatsappChannel.channelName"),
                    name: "channelName",
                  },
                  model: {
                    value: _vm.clone.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone, "name", $$v)
                    },
                    expression: "clone.name",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [
                  _vm._v(
                    _vm._s(_vm.$t("whatsapp_business_api.phoneNumberE164"))
                  ),
                ]),
                _vm._v(" "),
                _c("a-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t(
                      "whatsapp_business_api.phoneNumberE164Place"
                    ),
                    name: "phoneNumber",
                  },
                  model: {
                    value: _vm.clone.payload.phoneNumber,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone.payload, "phoneNumber", $$v)
                    },
                    expression: "clone.payload.phoneNumber",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.showVisibilityConfig
              ? _c("VisibilityChanger", {
                  model: {
                    value: _vm.clone.visibility,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone, "visibility", $$v)
                    },
                    expression: "clone.visibility",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("ChannelForwardSetting", {
        attrs: { channel: _vm.clone },
        on: {
          input: function (c) {
            return (_vm.clone = c)
          },
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c(
              "a-button",
              { staticClass: "cancel-btn", on: { click: _vm.handleCancel } },
              [_vm._v(_vm._s(_vm.$t("billing.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "pr-confirm-btn",
                attrs: { type: "primary", disabled: _vm.loading },
                on: { click: _vm.updateChannelData },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("billing.save")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }